import { render } from "./AFileInput.vue?vue&type=template&id=12203c59"
import script from "./AFileInput.vue?vue&type=script&lang=js"
export * from "./AFileInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__